// extracted by mini-css-extract-plugin
export default {"page_container":"SigninForm_page_container__i4SOj","container":"SigninForm_container__ClXGd","inputContainer":"SigninForm_inputContainer__v6mjp","button":"SigninForm_button__xjI2m"};